import { find } from "lodash";
import {
  ObjectWithAttendees,
  getAttendeeResponseStatusFromEvent,
} from "./getAttendeeResponseStatusFromEvent";

type ObjectWithEventKey = {
  eventKey?: {
    externalEventId: string;
  };
};

export type ObjectWithEventsWithAttendees = {
  events?: (ObjectWithEventKey & ObjectWithAttendees)[];
};

export const getAttendeeResponseStatusFromEventParent = (
  eventParent: ObjectWithEventsWithAttendees | null | undefined,
  externalEventId: string,
  calendarId: string,
) => {
  if (!eventParent) return undefined;

  const events = eventParent?.events;
  const event = find(events, (event) => event?.eventKey?.externalEventId === externalEventId);

  if (!event) return undefined;

  if (!event.attendees) return undefined;

  return getAttendeeResponseStatusFromEvent(event, calendarId);
};
